/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {PaginationCriteriaContract} from '../../api/contracts/pagination-criteria.contract';
import {PaginationCriteriaModel} from './pagination-criteria.model';

export class PaginationCriteriaMapper {

    static fromPaginationCriteriaContract(input: PaginationCriteriaContract): PaginationCriteriaModel {
        let model: PaginationCriteriaModel;

        if (input != null) {
            model = {
                firstResult: input.firstResult,
                maxResults: input.maxResults
            };
        }
        return model;
    }

    static toPaginationCriteriaContract(input: PaginationCriteriaModel): PaginationCriteriaContract {
        let model: PaginationCriteriaContract;

        if (input != null) {
            model = {
                firstResult: input.firstResult,
                maxResults: input.maxResults
            };
        }
        return model;
    }
}
